module.exports = __webpack_public_path__ + "static/media/nextBlack.e6365ded.svg";